import { HttpForm } from "../Support/HttpForm";
import { axios } from "../Support/Axios";
export class Product extends HttpForm {
    all(params = {}) {
        const url = '/api/product/all';
        return axios.get(url, {
            params: params
        }).catch(e => this.setError(e));
    }
    search(params = {}) {
        const url = '/api/product/search';
        return axios.post(url, params).catch(e => this.setError(e));
    }
}
